import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { BrandContentService } from './core/services/brand-content.service';
import { NewsContentService } from './core/home-banner/services/news-content.service';
import { PublicService } from './components/PublicationsPage/PublicationsPage.service';
import { eventpageService } from './components/eventpage/eventpage.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent   {
  showHomeHeader: boolean = false;

  data:any

  marqueeData:any
  private _NewsContentService: any;
  pupdata: any;
  eventdata: any;



  constructor(
    private router: Router,
    private _BrandContentService: BrandContentService,
    // private _NewsContentService: NewsContentService,
    private _PublicService:PublicService,
    private _eventpageService:eventpageService
  ) {
    this._eventpageService.watch().valueChanges.subscribe((resultt:any)=>{
      this.eventdata = resultt['data']['queryEventsPageContents'];
      console.log("eventdata", this.eventdata);
    })
    this._PublicService.watch().valueChanges.subscribe((result:any)=>{
      this.pupdata = result['data']['queryPublicationsPageContents'];
      console.log("pupMartina",result);
    })


    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.showHomeHeader = (event.url === '/'); // Adjust '/home' based on your actual home route
 
    });

    sessionStorage.setItem('currentlang','en');

this._BrandContentService.watch().valueChanges.subscribe(
  (resultData :any)=> {
      this.data = resultData.data.queryBrandContents[0].flatData;
      console.log("Martina",  this.data)
  }
)

  }
}